module.exports = __webpack_public_path__ + "img/31800.fd07f595.jpg";